export default function isObj(value: unknown): value is object {
  return typeof value === 'object' && !Array.isArray(value) && value !== null;
}
